var angularModule = angular.module('t2g.common.services.socketService', []);

module.exports = angularModule;

angularModule.factory('io', function($rootScope) {
  var socketIO;

  if (typeof io !== 'undefined') {
    socketIO = io;
  } else {
    socketIO = function() {
      return {
        on: angular.noop,
        emit: angular.noop,
        removeAllListeners: angular.noop,
      };
    };
  }
  var socket = socketIO('', { path: '/api/socket.io' });

  return {
    emit: emit,
    off: off,
    on: on,
  };

  function on(eventName, callback) {
    socket.on(eventName, function() {
      var args = arguments;
      $rootScope.$apply(function() {
        callback.apply(socket, args);
      });
    });
  }

  function emit(eventName, data, callback) {
    socket.emit(eventName, data, function() {
      var args = arguments;
      $rootScope.$apply(function() {
        if (callback) {
          callback.apply(socket, args);
        }
      });
    });
  }

  function off() {
    socket.removeAllListeners();
  }
});



// WEBPACK FOOTER //
// ./src/app/common/services/SocketService.js